import { CEWorkAttributesBase } from './ce-work-attributes-base'


export class CEWorkAttributes extends CEWorkAttributesBase {

}